export const tooltipRoles = {
    ALERT_DIALOG: 'alertdialog',
    DIALOG: 'dialog',
    GRID: 'grid',
    LISTBOX: 'listbox',
    MENU: 'menu',
    TOOLTIP: 'tooltip',
    TREE: 'tree',
};
